var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgArrowDownLong = function SvgArrowDownLong(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M6.75 1a.75.75 0 0 0-1.5 0h1.5ZM5.47 20.53a.75.75 0 0 0 1.06 0l4.773-4.773a.75.75 0 0 0-1.06-1.06L6 18.939l-4.243-4.242a.75.75 0 1 0-1.06 1.06L5.47 20.53ZM5.25 1v19h1.5V1h-1.5Z",
    fill: "currentColor"
  })));
};
export default SvgArrowDownLong;